import React, { useState } from 'react';
import './Location.css';

const Location = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    checkin: '',
    checkout: '',
    guests: '1',
    roomType: 'compartida',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí se puede agregar la lógica para enviar el formulario
    console.log('Formulario enviado:', formData);
    alert('¡Gracias por tu interés! Nos pondremos en contacto contigo pronto.');
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      checkin: '',
      checkout: '',
      guests: '1',
      roomType: 'compartida',
      message: ''
    });
  };

  return (
    <section id="ubicacion" className="location">
      <div className="container">
        <div className="location-header">
          <h2 className="section-title">Ubicación & Transporte</h2>
          <div className="title-underline"></div>
        </div>

        <div className="location-content">
          <div className="location-info">
            <h3>📍 Dónde Encontrarnos</h3>
            <div className="address-box">
              <h4>KAWILA HOSTEL & COFFEE</h4>
              <p>Santa Ana, El Salvador</p>
              <p className="location-description">
                Estamos ubicados en el corazón de Santa Ana, en una hermosa propiedad
                colonial de fácil acceso. Nuestra ubicación privilegiada te permite
                explorar la ciudad y sus alrededores con facilidad.
              </p>
            </div>

            <div className="transport-info">
              <h4>🚗 Transporte</h4>
              <div className="transport-grid">
                <div className="transport-card">
                  <span className="transport-icon">✈️</span>
                  <h5>Desde el Aeropuerto</h5>
                  <p>Servicio de Uber exclusivo para nuestros huéspedes</p>
                </div>
                <div className="transport-card">
                  <span className="transport-icon">🚌</span>
                  <h5>Transporte Público</h5>
                  <p>A pocos minutos de paradas de buses y terminal</p>
                </div>
                <div className="transport-card">
                  <span className="transport-icon">🚕</span>
                  <h5>Taxi & Uber</h5>
                  <p>Fácil acceso a servicios de transporte en la zona</p>
                </div>
              </div>
            </div>

            <div className="nearby-attractions">
              <h4>🗺️ Cerca de Nosotros</h4>
              <ul>
                <li>Centro histórico de Santa Ana</li>
                <li>Catedral de Santa Ana</li>
                <li>Teatro Nacional de Santa Ana</li>
                <li>Volcán de Santa Ana (Ilamatepec)</li>
                <li>Lago de Coatepeque</li>
                <li>Ruta de las Flores</li>
              </ul>
            </div>
          </div>

          <div className="map-placeholder">
            <div className="map-icon">🗺️</div>
            <p>Mapa de ubicación</p>
            <p className="map-note">Santa Ana, El Salvador</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
